import clsx from 'clsx';
import React from 'react';

export const NoDataFound = ({ className, title }) => {
  return (
    <div className={clsx('text-body', className)}>
      {title ? title : 'Κανένα αποτέλεσμα'}
    </div>
  );
};
